<template>

    <v-layout row wrap>
        <v-flex xs12 md6
                v-for="campaign in loyaltycampaings"
                :key="campaign.name"
        >
            <!--The card representing the Campaign can be defined with 3 elements:
            1 - image   2 - title   3 - short description
            It is mandatory to have an image or a title; the description is optional. -->
            <v-card>
                <v-img v-if="campaign.image && baseUrl"
                       v-bind:src="baseUrl + campaign.image" height="300">
                    <v-container fill-height fluid pa-2>
                        <v-layout fill-height>
                            <v-flex xs12 align-end flexbox>
                                <span v-if="campaign.name" class="headline" v-text="campaign.name"></span>
                            </v-flex>
                            <!--<v-flex xs12 align-end flexbox>-->
                            <!--<span class="headline white&#45;&#45;text" v-text="card.start_date"></span>-->
                            <!--</v-flex>-->
                            <!--<v-flex xs12 align-end flexbox>-->
                            <!--<span class="headline white&#45;&#45;text" v-text="card.start_end"></span>-->
                            <!--</v-flex>-->
                        </v-layout>
                    </v-container>
                </v-img>
                <v-card-title primary-title v-if="campaign.description">
                    <div v-if="campaign.priority === 1"
                         class="headline text-truncate">
                        {{ campaign.description }}
                    </div>
                    <div v-else
                         class="text-truncate">
                        {{ campaign.description }}
                    </div>
                </v-card-title>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {loyaltyCampaingsService} from '../../_services'
import {getErrorMessage} from '../../_helpers'
import {mapGetters} from "vuex";

export default {
    name: "Campaigns",
    data: () => {
        return {
            loyaltycampaings: [],
        }
    },
    computed: {
        ...mapGetters({
            baseUrl: 'configs/apiImgBaseUrl',
        }),
    },
    mounted() {
        this.$store.dispatch("loader/setLoading", true);
        loyaltyCampaingsService.getAll().then(result => {
                this.loyaltycampaings = result.results;
                this.$store.dispatch("loader/setLoading", false);
            },
            error => {
                getErrorMessage(error, 'Getting the Campaigns', this);
            }
        );
    }
}
</script>

<style scoped>

</style>